import axios from "axios";
import { Dispatch, SetStateAction } from "react";
import { AnyIfEmpty } from "react-redux";
import {
    CREATE_SUPPORT_TICKET_FAILURE,
    CREATE_SUPPORT_TICKET_REQUEST,
    CREATE_SUPPORT_TICKET_SUCCESS,
    GET_SUPPORT_TICKET_FAILURE,
    GET_SUPPORT_TICKET_REQUEST,
    GET_SUPPORT_TICKET_SUCCESS,
    GET_SUPPORT_TICKET_DETAIL_REQUEST,
    GET_SUPPORT_TICKET_DETAIL_SUCCESS,
    GET_SUPPORT_TICKET_DETAIL_FAILURE,
    POST_SUPPORT_TICKET_COMMENT_FAILURE,
    POST_SUPPORT_TICKET_COMMENT_REQUEST,
    POST_SUPPORT_TICKET_COMMENT_SUCCESS,
    UPDATE_SUPPORT_TICKET_STATUS_FAILURE,
    UPDATE_SUPPORT_TICKET_STATUS_REQUEST,
    UPDATE_SUPPORT_TICKET_STATUS_SUCCESS,
} from "../constants/support-ticket.constants";

interface CreateSupportTicketPayload {
    locationId?: string;
    subject: string;
    description: string;
}

const getSupportTicketRequest = () => ({
    type: GET_SUPPORT_TICKET_REQUEST,
});

const getSupportTicketSuccess = (supportTicketData: AnyIfEmpty<object>) => ({
    type: GET_SUPPORT_TICKET_SUCCESS,
    payload: supportTicketData,
});

const getSupportTicketFailure = (supportTicketError: string) => ({
    type: GET_SUPPORT_TICKET_FAILURE,
    payload: supportTicketError,
});

const getSupportTicketDetailRequest = () => ({
    type: GET_SUPPORT_TICKET_DETAIL_REQUEST,
});

const getSupportTicketDetailSuccess = (supportTicketDetailData: AnyIfEmpty<object>) => ({
    type: GET_SUPPORT_TICKET_DETAIL_SUCCESS,
    payload: supportTicketDetailData,
});

const getSupportTicketDetailFailure = (supportTicketDetailError: string) => ({
    type: GET_SUPPORT_TICKET_DETAIL_FAILURE,
    payload: supportTicketDetailError,
});

const updateSupportTicketStatusRequest = () => ({
    type: UPDATE_SUPPORT_TICKET_STATUS_REQUEST,
});

const updateSupportTicketStatusSuccess = (message: string) => ({
    type: UPDATE_SUPPORT_TICKET_STATUS_SUCCESS,
    payload: message,
});

const updateSupportTicketStatusFailure = (error: string) => ({
    type: UPDATE_SUPPORT_TICKET_STATUS_FAILURE,
    payload: error,
});

export const getSupportTickets = ({
    searchText,
    page,
    limit,
    ticketStatus,
    location,
}: {
    searchText: string;
    page: number;
    limit: number;
    ticketStatus?: string[];
    location?: string[];
}) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {

        dispatch(getSupportTicketRequest());
        const params: Record<string, string | number> = {
            searchText: searchText,
            page: page,
            limit: limit,
        };
        if (ticketStatus?.length) {
            params.ticketStatus = ticketStatus.join(',');
        }
        if (location?.length) {
            params.location = location.join(',');
        }
        return axios
            .get("/admin/support-ticket", { params })
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    const data = response.data.data ?? [];
                    const count = response.data.count ?? data.length;
                    dispatch(getSupportTicketSuccess({ data, count }));
                } else {
                    dispatch(getSupportTicketFailure(response.data.message));
                }
            })
            .catch((error) => {
                dispatch(
                    getSupportTicketFailure(
                        error?.response?.data?.message || "Something went wrong"
                    )
                );
            });
    };
};

export const createSupportTicket = (
    ticketData: CreateSupportTicketPayload,
    setLoading: Dispatch<SetStateAction<boolean>>,
    onSuccess?: (message: string) => void,
    onFailure?: (message: string) => void
) => {
    return () => {
        setLoading(true);
        return axios.post("/admin/support-ticket", ticketData)
            .then((response) => {
                if (response?.data?.statusCode === 201 || response?.data?.statusCode === 200) {
                    onSuccess && onSuccess(response.data.message || "Support ticket created successfully");
                } else {
                    onFailure && onFailure(response.data.message || "Something went wrong");
                }
            })
            .catch((error) => {
                onFailure && onFailure(error?.response?.data?.message || "Something went wrong");
            })
            .finally(() => {
                setLoading(false);
            });
    };
};

export const getSupportTicketDetail = (id: string, silent = false) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        if (!silent) dispatch(getSupportTicketDetailRequest());
        return axios.get(`/admin/support-ticket/${id}`)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    dispatch(getSupportTicketDetailSuccess(response.data.data));
                } else {
                    dispatch(getSupportTicketDetailFailure(response.data.message));
                }
            })
            .catch((error) => {
                dispatch(getSupportTicketDetailFailure(error?.response?.data?.message || "Something went wrong"));
            });
    };
};

export const CreateSupportTicketComment = (
    ticketId: string,
    comment: string,
    onSuccess?: (message: string) => void,
    onFailure?: (message: string) => void
) => {
    return () => {
        return axios.post("/admin/support-ticket/comment", {
            ticketId,
            comment,
        })
            .then((response) => {
                if (response?.data?.statusCode === 201 || response?.data?.statusCode === 200) {
                    onSuccess && onSuccess(response.data.message);
                } else {
                    onFailure && onFailure(response.data.message);
                }
            })
            .catch((error) => {
                onFailure && onFailure(error?.response?.data?.message || "Something went wrong");
            });

    };
};

export const updateSupportTicketStatus = (
    ticketId: string,
    ticketStatus: "re_open" | "closed",
    reason: string,
    onSuccess?: (message: string) => void,
    onFailure?: (message: string) => void
) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        return axios.patch(`/admin/support-ticket/${ticketId}/ticketStatus`, {
            ticketStatus,
            reason,
        })
            .then((response) => {
                if (response?.data?.statusCode === 200 || response?.data?.statusCode === 201) {
                    dispatch(getSupportTicketDetail(ticketId));
                    onSuccess && onSuccess(response.data.message);
                } else {
                    onFailure && onFailure(response.data.message);
                }
            })
            .catch((error) => {
                onFailure && onFailure(error?.response?.data?.message || "Something went wrong");
            });
    };
};